import { useIntl } from "react-intl";

import { RovoLogo } from "@atlaskit/logo";
import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { ProductPageSubNav } from "@/patterns/global-nav/src";

export const RovoNav = () => {
    const intl = useIntl();

    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: useLocalizedHref("/software/rovo/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: useLocalizedHref("/software/rovo/pricing")
        },
        {
            globalLinksKey: "artificial-intelligence",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.artificial-intelligence",
                defaultMessage: "Atlassian Intelligence"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: useLocalizedHref("/platform/artificial-intelligence")
        }
    ];

    return (
        <UFOSegment name="confluence-pt-cfind-1234-RovoNav">
            <ProductPageSubNav
                productLogoUrl="/software/rovo"
                productLogo={<RovoLogo appearance="brand" />}
                productLogoAriaLabel={intl.formatMessage({
                    id: "RovoPageTemplate.navbar.rovo-logo",
                    defaultMessage: "Rovo logo"
                })}
                mobileLogo={<RovoLogo appearance="brand" />}
                isShowTryNowLink={false}
                isIncludeMobileCTA={false}
                productPageNavLinks={navLinks}
                mobileLinksSections={[
                    {
                        mobileLinkKey: "mobile-rovo",
                        mobileLinksProps: navLinks
                    }
                ]}
            />
        </UFOSegment>
    );
};
